import { render, staticRenderFns } from "./MelosPlayer.vue?vue&type=template&id=0745e67f&"
import script from "./MelosPlayer.vue?vue&type=script&lang=ts&"
export * from "./MelosPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports